/*
	Принимает ISO-строку вроде "026-04-01T09:12:28.501480+00:00"
	и возвращает 1 квіт 2026, 09:12
*/

export const formatISODate = (iso: string): string => {
	if (!iso) return "";

	let s = iso.trim();

	// Поправка возможной опечатки в годе: "026-..." -> "2026-..."
	const yearMatch = s.match(/^(\d+)-/);
	if (yearMatch && yearMatch[1].length === 3) {
		s = "2" + s;
	}

	// Обрезаем лишние знаки после десятичной точки в секундах (JS корректно парсит до миллисекунд)
	s = s.replace(/(\.\d{3})\d+/, "$1");

	const date = new Date(s);
	if (isNaN(date.getTime())) {
		// если не удалось распарсить, возвращаем исходную строку
		return iso;
	}

	const day = date.getDate();
	let month = date.toLocaleString("uk-UA", { month: "short" });
	month = month.replace(".", ""); // убираем точку, если есть (напр. "квіт.")
	const year = date.getFullYear();
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");

	return `${day} ${month} ${year}, ${hours}:${minutes}`;
};
